// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1d2WJ","col":"CardReaderDesc_col__3_FCO","label":"CardReaderDesc_label__3aEqf"};